import './_product-image-options.scss';
import component from './product-image-options';

export default component;
